window.vm2log = (val) => console.log('  vm2log =>', val) ?? val;
